import { action, makeObservable, observable } from "mobx";

export class ExpandableKeys {
  constructor(initialValues = []) {
    makeObservable(this, {
      keys: observable,
      add: action,
      remove: action,
      setKeys: action,
    });

    this.setKeys(initialValues);
  }

  keys: Array<number | string> = [];

  setKeys = (keys) => {
    this.keys = keys;
  };

  remove = (key) => {
    this.keys = this.keys.filter((item) => item !== key);
  };

  add = (key) => {
    const el = this.keys.find((item) => item === key);
    if (!el) {
      this.keys.push(key);
    }
  };
}
